function openPopup() {
    document.getElementById('popup').style.display = 'block';
    document.getElementById('video').src += "?autoplay=1";
  }

/*
*/
function closePopup() {
    document.getElementById('popup').style.display = 'none';
    var videoIframe = document.getElementById('video');
    var videoSrc = videoIframe.src;
    videoIframe.src = '';
    videoIframe.src = videoSrc.replace('?autoplay=1', '');
  }



document.addEventListener('DOMContentLoaded', function () {
        const headings = document.querySelectorAll('.footer-block__heading');

        headings.forEach((heading) => {
            heading.addEventListener('click', function () {
                const content = this.nextElementSibling;
                const parentDiv = this.parentElement;
    
                // Close all other open sections
                document.querySelectorAll('.footer-block__details-content').forEach((item) => {
                    if (item !== content && item.classList.contains('open')) {
                        item.classList.remove('open');
                        item.style.maxHeight = '0';
                        item.parentElement.classList.remove('active');
                    }
                });
    
                content.classList.toggle('open');
    
                if (content.classList.contains('open')) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    parentDiv.classList.add('active');
                } else {
                    content.style.maxHeight = '0';
                    parentDiv.classList.remove('active');
                }
            });
        });
    });

